import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  app = firebase.initializeApp({
    apiKey: "AIzaSyAZ3rKc7BTnCtERu_tFq3cYB4BzH6jz4A8",
    authDomain: "bitl-it.firebaseapp.com",
    databaseURL: "https://bitl-it.firebaseio.com",
    projectId: "bitl-it",
    storageBucket: "bitl-it.appspot.com",
    messagingSenderId: "977442481059"
  });
  analytics = firebase.initializeApp({
    apiKey: "AIzaSyAtdsNua9-6hdU_YcshrTsROlWnmAJ-PnE",
    authDomain: "bitl-it-analytics.firebaseapp.com",
    databaseURL: "https://bitl-it-analytics.firebaseio.com",
    projectId: "bitl-it-analytics",
    storageBucket: "bitl-it-analytics.appspot.com",
    messagingSenderId: "228088479933"
  }, 'bitl-it-analytics');

  userService;

  constructor(
    public router: Router,
  ) {
    this.userService = new UserService();
    // firebase.auth().onAuthStateChanged((user) => {
    //   console.log(user)
    //   if (user) {
    //     this.userService.initProfile(user.uid);
    //   } else {

    //   }
    //   if (user && (router.url === '/' || router.url.includes('login'))) {
    //     this.router.navigateByUrl('/links');
    //   }
    // });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts